/**
 * AiRequestLogService
 * Read-only service for querying AI request logs
 */
import { BaseService } from '../base/BaseService';
/**
 * Read-only service for AI request log queries
 */
export class AiRequestLogService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AiRequestLogService.DEFAULT_SERVICE_PATH,
            basePath: AiRequestLogService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET BY VENDOR ====================
    /**
     * Get request logs for a vendor with pagination
     * @param vendorId - The vendor ID
     * @param page - Page number (optional)
     * @param pageSize - Number of items per page (optional)
     * @returns Array of request logs
     */
    async getByVendor(vendorId, page, pageSize) {
        const response = await this.getByVendorRaw(vendorId, page, pageSize);
        return response.data ?? [];
    }
    /**
     * Get request logs for a vendor with pagination and full response
     * @param vendorId - The vendor ID
     * @param page - Page number (optional)
     * @param pageSize - Number of items per page (optional)
     * @returns ResponseData with array of request logs
     */
    getByVendorRaw(vendorId, page, pageSize) {
        const url = this.buildUrlWithParams(`vendor/${vendorId}`, { page, pageSize });
        return this.http.get(url);
    }
    // ==================== GET BY ID ====================
    /**
     * Get a request log by ID
     * @param id - The request log ID
     * @returns The request log
     * @throws Error if not found
     */
    async getById(id) {
        const response = await this.getByIdRaw(id);
        if (!response.data) {
            throw new Error(`Request log with ID ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get a request log by ID with full response
     * @param id - The request log ID
     * @returns ResponseData with the request log
     */
    getByIdRaw(id) {
        const url = this.buildUrl(String(id));
        return this.http.get(url);
    }
}
AiRequestLogService.DEFAULT_SERVICE_PATH = 'ai-management';
AiRequestLogService.BASE_PATH = 'api/ai/request-logs';
//# sourceMappingURL=AiRequestLogService.js.map